import estoreVouchers from "../services/estore.vouchers";
import notification from "../services/notification";
import { getField, updateField } from "vuex-map-fields";

export default {
    namespaced: true,
    state: {
        loading: false,
        successMessage: "",
        errors: null,
        csvErrors: null,
        modal: {
            new: {
                status: false
            },
            edit: {
                status: false,
                uuid: null
            },
            delete: {
                status: false,
                uuid: null,
                name: ""
            },
            storeVouchers: {
                status: false,
                uuid: null,
                name: ""
            },
            csvErrors: {
                status: false
            }
        },
        storeVouchers: [],
        storeVoucher: {
            promo_code_type: "",
            branch_uuids: [],
            selected_all_brands_branches: false,
            category_uuids: [],
            terms_and_conditions: ""
        },
        storeVoucherCodes: [],
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        },
        voucherCodesPagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        },
        advancedOptions: [
            {
                value: "all",
                text: "All"
            },
            {
                value: true,
                text: "Visibility On"
            },
            {
                value: false,
                text: "Visibility Off"
            }
        ],
        selectedAdvancedOption: "all",
        keyword: "",
        emptyText: "No records found",
        isSearching: false,
        storeVoucherCodesAdvancedOptions: [
            {
                value: "all",
                text: "All"
            },
            {
                value: true,
                text: "Used"
            },
            {
                value: false,
                text: "Unused"
            }
        ],
        storeVoucherCodesSelectedAdvancedOption: "all",
        storeVoucherCodesKeyword: "",
        storeVoucherCodesEmptyText: "No records found",
        storeVoucherCodesIsSearching: false,
        selectedPromoCodeCategories: [],
        selectedPromoCodeBrandBranch: []
    },
    mutations: {
        updateField,
        loading(state, value = true) {
            state.loading = value;
        },
        setSuccessMessage(state, value) {
            state.successMessage = value;
        },
        errors(state, errors) {
            state.errors = errors;
        },
        csvErrors(state, csvErrors) {
            state.csvErrors = csvErrors;
        },
        setModal(state, modal) {
            state.modal[modal.type].status = modal.status;
            if (modal.uuid !== undefined) {
                state.modal[modal.type].uuid = modal.uuid;
            }
            if (modal.name !== undefined) {
                state.modal[modal.type].name = modal.name;
            }
        },
        resetErrors(state) {
            state.errors = null;
            state.loading = false;
        },
        resetCsvErrors(state) {
            state.csvErrors = null;
            state.loading = false;
        },
        storeVouchers(state, storeVouchers) {
            state.storeVouchers = storeVouchers;
            state.loading = false;
            state.searching = false;
        },
        setStoreVoucher(state, storeVoucher) {
            state.storeVoucher = storeVoucher;
        },
        setInitialPageCount(state, list) {
            state.pagination.initialPageCount = list.length;
        },
        pagination(state, pagination) {
            state.pagination.totalPerPage = pagination.list.length;
            state.pagination.maxPage = pagination.max_page;
            state.pagination.prevPage = pagination.prev_page;
            state.pagination.nextPage = pagination.next_page;
            state.pagination.currentPage = state.pagination.prevPage + 1;
            state.pagination.currentFirstItem =
                state.pagination.initialPageCount * state.pagination.prevPage +
                1;
            state.pagination.currentLastItem =
                state.pagination.currentFirstItem > 0
                    ? state.pagination.currentFirstItem +
                      state.pagination.totalPerPage -
                      1
                    : 0;
        },
        storeVoucherCodes(state, storeVoucherCodes) {
            state.storeVoucherCodes = storeVoucherCodes;
            state.loading = false;
            state.searching = false;
        },
        setVoucherCodesInitialPageCount(state, list) {
            state.pagination.initialPageCount = list.length;
        },
        voucherCodesPagination(state, pagination) {
            state.voucherCodesPagination.totalPerPage = pagination.list.length;
            state.voucherCodesPagination.maxPage = pagination.max_page;
            state.voucherCodesPagination.prevPage = pagination.prev_page;
            state.voucherCodesPagination.nextPage = pagination.next_page;
            state.voucherCodesPagination.currentPage =
                state.voucherCodesPagination.prevPage + 1;
            state.voucherCodesPagination.currentFirstItem =
                state.voucherCodesPagination.initialPageCount *
                    state.voucherCodesPagination.prevPage +
                1;
            state.voucherCodesPagination.currentLastItem =
                state.voucherCodesPagination.currentFirstItem > 0
                    ? state.voucherCodesPagination.currentFirstItem +
                      state.voucherCodesPagination.totalPerPage -
                      1
                    : 0;
        },
        setSelectedAdvancedOption(state, selectedAdvancedOption) {
            state.selectedAdvancedOption = selectedAdvancedOption;
        },
        setKeyword(state, keyword) {
            state.keyword = keyword;
        },
        setEmptyText(state, emptyText) {
            state.emptyText = emptyText;
        },
        setIsSearching(state, isSearching) {
            state.isSearching = isSearching;
        },
        setStoreVoucherCodesSelectedAdvancedOption(
            state,
            storeVoucherCodesSelectedAdvancedOption
        ) {
            state.storeVoucherCodesSelectedAdvancedOption = storeVoucherCodesSelectedAdvancedOption;
        },
        setStoreVoucherCodesKeyword(state, storeVoucherCodesKeyword) {
            state.storeVoucherCodesKeyword = storeVoucherCodesKeyword;
        },
        setStoreVoucherCodesEmptyText(state, storeVoucherCodesEmptyText) {
            state.storeVoucherCodesEmptyText = storeVoucherCodesEmptyText;
        },
        setStoreVoucherCodesIsSearching(state, storeVoucherCodesIsSearching) {
            state.storeVoucherCodesIsSearching = storeVoucherCodesIsSearching;
        }
    },
    getters: {
        getField,
        selectedPromoCodeCategories: state => state.selectedPromoCodeCategories,
        selectedPromoCodeBrandBranch: state =>
            state.selectedPromoCodeBrandBranch
    },
    actions: {
        async getStoreVouchers({ commit }, param) {
            commit("loading");
            try {
                let response = await estoreVouchers.getStoreVouchers(param);
                if (param.page == 1) {
                    await commit("setInitialPageCount", response.list);
                }
                await commit("storeVouchers", response.list);
                await commit("pagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async saveStoreVoucher({ commit }, param) {
            commit("loading", true);
            commit("setSuccessMessage", "");

            try {
                let response = await estoreVouchers.saveStoreVoucher(param);
                if (
                    response.csv_error != undefined &&
                    response.csv_error.length > 0
                ) {
                    commit("setModal", {
                        type: "csvErrors",
                        status: true
                    });
                    commit("csvErrors", response.csv_error);
                }
                commit("setSuccessMessage", response.message);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async deleteStoreVoucher({ commit }, uuid) {
            commit("loading");
            try {
                let response = await estoreVouchers.deleteStoreVoucher(uuid);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                if (errors.errors.message) {
                    notification.warning(errors.errors.message);
                } else {
                    notification.warning("Oops, cannot update promo code.");
                }
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async viewStoreVoucher({ commit, state }, uuid) {
            commit("loading");
            try {
                let response = await estoreVouchers.viewStoreVouchers(uuid);
                response.store_voucher.value = parseFloat(
                    response.store_voucher.value
                ).toFixed(2);

                response.store_voucher.minimum_spend = parseFloat(
                    response.store_voucher.minimum_spend
                ).toFixed(2);

                response.store_voucher.maximum_discount_value = parseFloat(
                    response.store_voucher.maximum_discount_value
                ).toFixed(2);

                response.store_voucher.delivery_discount_value = parseFloat(
                    response.store_voucher.delivery_discount_value
                ).toFixed(2);

                if (response.store_voucher.voucher_type == "generic") {
                    response.store_voucher.generic_code =
                        response.store_voucher.voucher_codes[0].code;
                } else {
                    response.store_voucher.voucher_codes = null;
                }

                response.store_voucher.is_date_applicable = Boolean(
                    response.store_voucher.is_date_applicable
                );

                if (!response.store_voucher.is_date_applicable) {
                    response.store_voucher.start_date = null;
                    response.store_voucher.end_date = null;
                }

                response.store_voucher.is_time_applicable = Boolean(
                    response.store_voucher.is_time_applicable
                );

                response.store_voucher.is_unlimited = Boolean(
                    response.store_voucher.is_unlimited
                );

                if (response.store_voucher.is_unlimited) {
                    response.store_voucher.code_quantity = "";
                }

                response.store_voucher.is_website_applicable = Boolean(
                    response.store_voucher.is_website_applicable
                );

                response.store_voucher.is_customer_app_applicable = Boolean(
                    response.store_voucher.is_customer_app_applicable
                );

                response.store_voucher.is_gcash_mp_applicable = Boolean(
                    response.store_voucher.is_gcash_mp_applicable
                );

                commit("setStoreVoucher", {
                    ...state.storeVoucher,
                    ...response.store_voucher
                });
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async updateStoreVoucher({ commit }, data) {
            commit("loading", true);
            commit("setSuccessMessage", "");

            try {
                let response = await estoreVouchers.updateStoreVoucher(
                    data.uuid,
                    data.param
                );
                commit("setSuccessMessage", response.message);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async viewStoreVoucherCodes({ commit }, param) {
            commit("loading");
            try {
                let response = await estoreVouchers.viewStoreVoucherCodes(
                    param
                );
                if (param.page == 1) {
                    await commit(
                        "setVoucherCodesInitialPageCount",
                        response.list
                    );
                }
                await commit("storeVoucherCodes", response.list);
                await commit("voucherCodesPagination", response);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async resetErrors({ commit }) {
            commit("resetErrors");
        },
        async updateVoucherVisibility({ commit }, payload) {
            commit("loading", true);
            commit("errors", null);

            try {
                const {
                    message
                } = await estoreVouchers.updateVoucherVisibility(payload);
                notification.success(message);
            } catch (errors) {
                notification.warning(
                    `Oops, cannot ${
                        payload.is_enable ? "enable" : "disable"
                    } EStore Promo Code.`
                );
                commit("errors", errors);
                commit("loading", false);
            }
        }
    }
};
